// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__YDlqs"};